import React from "react";
import Popover from "../../../../../../../../common-deprecated/components/popover/aem/lexus/Popover";
import { type BuildAndBuyLabelType, BnbLabel } from "../../../../../utils/labels";
import * as Button from "../../../../../../../../common-deprecated/styles/v2/lexus/components/Button";
import type { PriceType, FinanceOptionType } from "../../../../../../../../common-deprecated/types/CommonTypes";
import Price from "../../price/Price";
import Icon from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import * as Styles from "../styles/BasketList";

type BasketItemRowType = {
    name: string;
    tooltip?: BuildAndBuyLabelType;
    price?: PriceType; // optional, return null if if we dont want to show a price
    priceFallback?: string; // show a string when price is 0, used to display "Standard" or nothing in some cases
    itemId?: string;
    financeOption?: FinanceOptionType;
    removeItem?: () => void;
};

const BasketItemRow = (props: BasketItemRowType): JSX.Element => {
    const { name, tooltip, price, priceFallback, itemId, removeItem, financeOption } = props;

    const hasPriceValue = price && (price.cash > 0 || price.discount > 0 || price.monthly > 0);
    const showSecondField = hasPriceValue || !!priceFallback || removeItem;

    return (
        <Styles.BasketListItem>
            <Styles.ListItemLabel>
                <Styles.ListItemLabelText>{name}</Styles.ListItemLabelText>
                {!!tooltip && (
                    <Popover showOnClick>
                        <BnbLabel label={tooltip} />
                    </Popover>
                )}
            </Styles.ListItemLabel>

            {showSecondField && (
                <Styles.ListItemValue hasPrice hasRemoveButton={!!removeItem}>
                    {hasPriceValue && price ? (
                        <Price price={price} financeItemId={itemId} financeOption={financeOption} />
                    ) : (
                        <div>{priceFallback}</div>
                    )}
                    {removeItem && (
                        <Styles.ActionWrapper>
                            <Button.Icon
                                onClick={() => {
                                    removeItem();
                                }}
                            >
                                <Icon variant="close" size="medium" />
                            </Button.Icon>
                        </Styles.ActionWrapper>
                    )}
                </Styles.ListItemValue>
            )}
        </Styles.BasketListItem>
    );
};

export default BasketItemRow;
